import React from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from 'react-bootstrap';
import { LocalizeContextProvider } from 'react-locale-language';
import { AppChoicesProvider } from './context/AppChoicesContext';
import { BrowserRouter as Router } from 'react-router-dom';
import { ParentCustomerProvider } from './context/ParentCustomerContext';

import App from './App';
import { getActiveLanguage, languageContent } from './helpers/localization';
import { UserProvider } from './context/UserContext';
import MobileScreenChecker from './pages/MobileScreenChecker';
import Clarity from '@microsoft/clarity';
Clarity.init(process.env.REACT_APP_CLARITY_PROJECT_ID);

createRoot(document.getElementById('root')).render(
  <LocalizeContextProvider value={languageContent} languageCode={getActiveLanguage()}>
    <Router>
      <ThemeProvider>
        <UserProvider>
          <MobileScreenChecker>
            <AppChoicesProvider>
              <ParentCustomerProvider>
                <App />
              </ParentCustomerProvider>
            </AppChoicesProvider>
          </MobileScreenChecker>
        </UserProvider>
      </ThemeProvider>
    </Router>
  </LocalizeContextProvider>
);
